export const RegiWallLoginMethodLocalstorageKey = "REGI_WALL_LOGIN_METHOD";
// TODO: Avoid hard coding this value. Instead, aim to capture the `meterName` dynamically and
//  trigger the event based on it.
export const MaxReadableArticleCountPerLoggedInUser = 5;
export const BeyondMaxReadableArticleCountPerLoggedInUser =
  MaxReadableArticleCountPerLoggedInUser + 1;

export const PaywallMeterViewsLocalstorageKey = "paywallMeterViews";
export const PaywallMeterViewsLeftLocalstorageKey = "paywallMeterViewsLeft";
